import { render, staticRenderFns } from "./InternshipSection.vue?vue&type=template&id=718f6fc4&"
import script from "./InternshipSection.vue?vue&type=script&lang=js&"
export * from "./InternshipSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports